import { useCallback, useEffect } from "react";
export default (function (ref) {
    var onWheel = useCallback(function (e) {
        var container = ref.current;
        container.scrollLeft = container.scrollLeft + e.deltaY * 0.1;
    });
    useEffect(function () {
        if (!ref.current)
            return;
        var container = ref.current;
        container.addEventListener("wheel", onWheel);
        return function () { return container.remove("wheel", onWheel); };
    }, []);
});
